import { styled } from '@linaria/react';
import { layout, radius, semantic, size, space } from '../../theme/tokens';

export const Carousel = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const Mosaic = styled.div`
  display: none;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: var(--hero-gallery-aspect-ratio, 1200 / 580);
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: ${space['space-200']};
  border-radius: ${radius('image', 'radius-lg')};
  overflow: hidden;

  &[data-count='0'],
  &[data-count='1'] {
    grid-template-columns: minmax(0, 1fr);
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: grid;
  }
`;

export const SecondaryGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: ${space['space-200']};

  &[data-count='3'] {
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }

  &[data-count='4'],
  &[data-count='5'] {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }

  &[data-count='4'] > *:last-child {
    grid-column: span 2;
  }
`;

export const Cell = styled.div`
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ShowAll = styled.div`
  position: absolute;
  right: ${space['space-400']};
  bottom: ${space['space-400']};
  z-index: 2;

  svg {
    width: ${size.icon['icon-md']};
    height: ${size.icon['icon-md']};
  }
`;
